module.exports = __webpack_public_path__ + "img/welcome_15.a25d0695.jpg";